module.exports = __webpack_public_path__ + "static/media/IconSprite.53a7e5c1.svg";